module.exports = __webpack_public_path__ + "static/media/img_background.f2f62146.svg";